import * as React from 'react'

export function useDevicePixelRatioObserver(onChange) {
  React.useEffect(() => {
    onChange(window.devicePixelRatio)
  }, [])
}
